import { AbstractControl } from '@angular/forms';

export function passwordValidator(
  control: AbstractControl
): { [key: string]: boolean } | null {
  let pass: AbstractControl = control;
  const patterns = ['[a-z]+', '[A-Z]+', '[0-9]+', '[$&+,:;=?@#|<>.^*()%!-]'];
  if (!String(pass.value).length) return { required: true };
  
  //La contraseña debe contener mínimo una letra en minuscula
  if (!String(pass.value).match(patterns[0])) return { lowerCase: true };
  
  //La contraseña debe contener mínimo una letra en mayuscula
  if (!String(pass.value).match(patterns[1])) return { upperCase: true };
  
  //La contraseña debe contener mínimo un número
  if (!String(pass.value).match(patterns[2])) return { numbers: true };
  
  //La contraseña debe contener mínimo un caracter especial
  if (!String(pass.value).match(patterns[3])) return { special: true };

  //La contraseña debe tener una longitud entre 10 a 50 caracteres
  if (String(pass.value).length < 10) return { min: true };
  if (String(pass.value).length > 50) return { max: true };

  return null;
}
